export default __webpack_public_path__ + "static/cFDnxZVe-b745a0b9d3007b945fd9ebc92ab0a3ea.svg";